export function getFileExtension(filename: string): string {
  return filename.split(".").pop()?.toLowerCase() ?? "";
}

export type FileTypeIconName = "FileText" | "FileSpreadsheet" | "FileImage" | "FileArchive" | "File";

export interface FileTypeVisual {
  icon: FileTypeIconName;
  colorClassName: string;
}

// File-type colors are mode-independent, so they use Tailwind's built-in palette directly
// rather than @noa/theme tokens.
const FILE_TYPE_VISUALS: Record<string, FileTypeVisual> = {
  PDF: { icon: "FileText", colorClassName: "text-red-500" },
  TXT: { icon: "FileText", colorClassName: "text-gray-500" },
  DOC: { icon: "FileText", colorClassName: "text-blue-500" },
  DOCX: { icon: "FileText", colorClassName: "text-blue-500" },
  XLS: { icon: "FileSpreadsheet", colorClassName: "text-green-500" },
  XLSX: { icon: "FileSpreadsheet", colorClassName: "text-green-500" },
  JPG: { icon: "FileImage", colorClassName: "text-purple-500" },
  JPEG: { icon: "FileImage", colorClassName: "text-purple-500" },
  PNG: { icon: "FileImage", colorClassName: "text-purple-500" },
  GIF: { icon: "FileImage", colorClassName: "text-purple-500" },
  BMP: { icon: "FileImage", colorClassName: "text-purple-500" },
  ZIP: { icon: "FileArchive", colorClassName: "text-orange-500" },
  RAR: { icon: "FileArchive", colorClassName: "text-orange-500" },
  "7Z": { icon: "FileArchive", colorClassName: "text-orange-500" },
};

const DEFAULT_FILE_TYPE_VISUAL: FileTypeVisual = { icon: "File", colorClassName: "text-gray-500" };

export function getFileTypeVisual(fileType?: string | null): FileTypeVisual {
  return FILE_TYPE_VISUALS[fileType?.toUpperCase() ?? ""] ?? DEFAULT_FILE_TYPE_VISUAL;
}
